import { LOCALES } from '../LOCALES';

const enUs = {
    [LOCALES.ENGLISH]: {
        AI_EDU_AI_ASSISTANT_ADMIN_PORTAL: 'Samsung AI Assistant',
        AI_EDU_SAMSUNG_EDUCATION: 'Samsung Education',
        AI_EDU_CREATE_ORG: 'Create Organization',
        AI_EDU_ADD_ORG_DETAILS:
            'Add organization detail to create new organization',
        AI_EDU_EMAIL_ADDRESS: 'Email Address',
        AI_EDU_EMAIL_CANNOT_BE_CHANGED: 'Email cannot be changed',
        AI_EDU_ORG_NAME: 'Organization Name',
        AI_EDU_ORG_ADDRESS: 'Organization Address',
        AI_EDU_ADDRESS: 'Address',
        AI_EDU_CITY: 'City',
        AI_EDU_COUNTRY: 'Country',
        AI_EDU_STATE_PROVINCE: 'State/ Province',
        AI_EDU_ZIP_CODE: 'ZIP/ Postal Code',
        AI_EDU_ORG_ADDED_TITLE: 'Organization is added successfully',
        AI_EDU_ORG_ADDED_SUBTITLE: 'Start adding, managing user and devices',
        AI_EDU_VIEW_DASHBOARD: 'View Dashboard',
        AI_EDU_DASHBOARD: 'Dashboard',
        AI_EDU_USERS: 'Users',
        AI_EDU_DEVICES: 'Devices',
        AI_EDU_TAG_MANAGEMENT: 'Tag Management',
        AI_EDU_ALERT_LOG: 'Alert Log',
        AI_EDU_ACTIVITY_LOG: 'Activity Log',
        AI_EDU_USER_SESSION: 'User Session',
        AI_EDU_CIRCLE_TO_SEARCH: 'Circle To Search',
        AI_EDU_LIVE_TRANSCRIPT: 'Live Transcript',
        AI_EDU_AI_SUMMARY: 'AI Summary',
        AI_EDU_LOGIN: 'Login',
        AI_EDU_SIGNUP: 'Sign Up',
        AI_EDU_SIGNOUT: 'Sign Out',
        AI_EDU_DELETE: 'Delete',
        AI_EDU_ADMIN: 'Admin',
        AI_EDU_USER: 'User',
        AI_EDU_UPDATE: 'Update',
        AI_EDU_NO_DATA_TO_SHOW: 'No data to show',
        AI_EDU_SEARCH_USER: 'Search User',
        AI_EDU_USER_ID: 'User ID',
        AI_EDU_USER_NAME: 'User Name',
        AI_EDU_NFC_TAG: 'NFC Tag',
        AI_EDU_EMAIL: 'Email',
        AI_EDU_ACCESS_TYPE: 'Access Type',
        AI_EDU_ACTION: 'Action',
        AI_EDU_SELECT_ACCESS_TYPE: 'Select Access Type',
        AI_EDU_ACCESS_TYPE_SUCCESS: 'User Access Type Updated.',
        AI_EDU_ACCESS_TYPE_FAILURE: 'Error in updating User Access Type.',
        AI_EDU_USER_APPROVED_SUCCESS: 'User Approved.',
        AI_EDU_USER_REJECTED_SUCCESS: 'User Rejected.',
        AI_EDU_USER_APPROVED_FAILURE: 'Error in Approving user.',
        AI_EDU_USER_REJECTED_FAILURE: 'Error in Rejecting user.',
        AI_EDU_DELETE_USER_TEXT:
            'Are you sure you want to delete the selected user(s)?',
        AI_EDU_YES: 'Yes',
        AI_EDU_NO: 'No',
        AI_EDU_CONFIRM: 'Confirm',
        AI_EDU_CLOSE: 'Close',
        AI_EDU_OK: 'Ok',
        AI_EDU_CANCEL: 'Cancel',
        AI_EDU_DONE: 'Done',
        AI_EDU_DELETE_ORG_PROMPT:
            'Are you sure ? Removing all admins will permanently delete this organization and all associated data.',
        AI_EDU_DELETE_DEVICE_TEXT:
            'Are you sure you want to delete the selected device(s) ?',
        AI_EDU_DELETE_TAG_TEXT:
            'Are you sure you want to delete the selected tag(s) ?',
        AI_EDU_DEVICE_DASHBOARD: 'View Device',
        AI_EDU_USER_DASHBOARD: 'View User',
        AI_EDU_DRAG_N_DROP: 'Drag & drop files here',
        AI_EDU_BROWSE_FILE: 'Browse File',
        AI_EDU_ADD_DEVICES_MANUALLY: 'Manual device addition',
        AI_EDU_ADD_USERS_MANUALLY: 'Manual user addition',
        AI_EDU_UPLOAD_FILE_TO_ADD_USER: 'Upload file to add user',
        AI_EDU_ADD_USER: 'Add User',
        AI_EDU_ADD_DEVICE: 'Add Device',
        AI_EDU_ADD_TAG: 'Add Tag',
        AI_EDU_SEARCH_DEVICE_MAC: 'Search Device',
        AI_EDU_SEARCH_TAG: 'Search Tag',
        AI_EDU_DEVICE_MAC: 'Device MAC',
        AI_EDU_DEVICE_NAME: 'Device Name',
        AI_EDU_TAG_NAME: 'Tag Name',
        AI_EDU_TAG_WEBHOOK_URL: 'Webhook URL',
        AI_EDU_TAG_API_KEY: 'API Key',
        AI_EDU_ADD_MORE: 'Add More',
        AI_EDU_SAVE: 'Save',
        AI_EDU_DUPLICATE_MAC: 'Duplicate MAC address found.',
        AI_EDU_INVALID_MAC_MSG:
            'Please enter valid MAC address for all devices.',
        AI_EDU_DOWNLOAD_FILE_FORMAT: 'Download File format',
        AI_EDU_UPLOAD_FILE: 'Upload File',
        AI_EDU_BULK_USER_ADDITION: 'Bulk user addition',
        AI_EDU_BULK_DEVICE_ADDITION: 'Bulk device addition',
        AI_EDU_ADD_ALL_USERS: 'Add All Users',
        AI_EDU_ADD_ALL_DEVICES: 'Add All Devices',
        AI_EDU_ORG_DETAILS: 'Organization details',
        AI_EDU_ADMIN_SETTINGS: 'Admin settings',
        AI_EDU_LINKED_VIA_MICROSOFT: 'Linked via microsoft account',
        AI_EDU_LINKED_VIA_GOOGLE: 'Linked via google account',
        AI_EDU_SEARCH_ALERT: 'Search Alert',
        AI_EDU_EMERGENCY_ALERT: 'Emergency Alert',
        AI_EDU_ADD_NEW: 'Add New',
        AI_EDU_UPDATED_DATE: 'Updated Date',
        AI_EDU_CREATED_DATE: 'Created Date',
        AI_EDU_ALERT_TITLE: 'Alert Title',
        AI_EDU_ALERT_PROVIDER: 'Alert Provider',
        AI_EDU_ALERT_TYPE: 'Alert Type',
        AI_EDU_XML_BODY: 'XML Body',
        AI_EDU_DISPLAY_SETTINGS: 'Display Settings',
        AI_EDU_TEMPLATE: 'Template',
        AI_EDU_BACKGROUND_COLOR: 'Background Color',
        AI_EDU_TEXT_COLOR: 'Text Color',
        AI_EDU_TEMPLATE_PREVIEW: 'Template Preview',
        AI_EDU_ALERT_DESCRIPTION: 'Alert Description',
        AI_EDU_DELETE_ALERT: 'Delete Alert',
        AI_EDU_NO_TEMPLATES_AVAILABLE: 'No templates available',
        AI_EDU_NO_SEARCH_RESULTS: 'No search results found',
        AI_EDU_ENTER_ALERT_TITLE: 'Enter alert title here',
        AI_EDU_ENTER_ALERT_DESCRIPTION:
            'Enter the description for this alert type',
        AI_EDU_SELECT_ALERT_PROVIDER: 'Select alert provider',
        AI_EDU_SELECT_ALERT_TYPE: 'Select alert type',
        AI_EDU_CREATE_NEW_ALERT: 'Create New Alert',
        AI_EDU_TEMPLATE_PREVIEW: 'Template Preview',
        AI_EDU_EDIT: 'Edit',
        AI_EDU_CREATE: 'Create',
        AI_EDU_PREVIEW_TITLE: 'Below is a preview of alert. Please confirm:',
        AI_EDU_NO_EMERGENCY_ALERTS_DESCRIPTION:
            'You have not create any emergency alert template now, you can try to create new template to manage different type alert showing effect in terminal devices.',
        AI_EDU_SELECTED_COUNT: 'selected',
        AI_EDU_ORGANIZATION_ID_REQUIRED: 'Organization ID is required',
        AI_EDU_ORGANIZATION_ID_REQUIRED_TO_FETCH_ALERTS:
            'Organization ID is required to fetch alerts',
        AI_EDU_ERROR_FETCHING_EMERGENCY_ALERTS:
            'Error fetching emergency alerts. Please try again.',
        AI_EDU_FAILED_TO_FETCH_TEMPLATES:
            'Failed to fetch templates. Please try again.',
        AI_EDU_ERROR_FETCHING_TEMPLATES:
            'Error fetching templates. Please try again.',
        AI_EDU_ERROR_FETCHING_ALERT_DATA:
            'Error fetching alert data. Please try again.',
        AI_EDU_ALERT_TITLE_REQUIRED: 'Alert title is required',
        AI_EDU_PROVIDER_REQUIRED: 'Provider is required',
        AI_EDU_ALERT_TYPE_REQUIRED: 'Alert type is required',
        AI_EDU_TEMPLATE_REQUIRED: 'Template is required',
        AI_EDU_BACKGROUND_COLOR_REQUIRED: 'Background color is required',
        AI_EDU_TEXT_COLOR_REQUIRED: 'Text color is required',
        AI_EDU_ORGANIZATION_ID_REQUIRED_TO_SAVE: 'Organization ID is required',
        AI_EDU_FAILED_TO_CREATE_EMERGENCY_ALERT:
            'Failed to create emergency alert. Please try again.',
        AI_EDU_ERROR_CREATING_EMERGENCY_ALERT:
            'Error creating emergency alert. Please try again.',
        AI_EDU_EMERGENCY_ALERT_UPDATED_SUCCESSFULLY:
            'Emergency alert updated successfully',
        AI_EDU_ERROR_UPDATING_EMERGENCY_ALERT:
            'Error updating emergency alert. Please try again.',
        AI_EDU_ORGANIZATION_ID_AND_ALERT_ID_REQUIRED:
            'Organization ID and Alert ID are required',
        AI_EDU_SELECT_AT_LEAST_ONE_EMERGENCY_ALERT:
            'Please select at least one emergency alert to delete',
        AI_EDU_SUCCESSFULLY_DELETED_EMERGENCY_ALERTS:
            'Successfully deleted {count} emergency alert(s)',
        AI_EDU_ERROR_DELETING_EMERGENCY_ALERTS:
            'Error deleting emergency alerts. Please try again.',
        AI_EDU_DELETE_EMERGENCY_ALERT_CONFIRMATION:
            'Are you sure you want to delete the selected emergency alert?',
        AI_EDU_DELETE_MULTIPLE_EMERGENCY_ALERTS_CONFIRMATION:
            'Are you sure you want to delete {count} selected emergency alerts?',
        AI_EDU_SELECT_COLOR: 'Select {color}',
        AI_EDU_DEVICE_TAG: 'Device Tag',
        AI_EDU_ENROLLED_DATE: 'Enrolled Date',
        AI_EDU_ASSIGN_TAG_TO_DEVICES: 'Assign Tag to Devices',
        AI_EDU_SELECT_AT_LEAST_ONE_DEVICE_TO_ASSIGN_TAG: 'Please select at least one device to assign a tag',
        AI_EDU_FAILED_TO_REMOVE_TAG_FROM_DEVICES: 'Failed to remove tag from devices',
        AI_EDU_SELECT_TAG_TO_ASSIGN: 'Please select a tag to assign',
        AI_EDU_FAILED_TO_ASSIGN_TAG_TO_DEVICES: 'Failed to assign tag to devices',
        AI_EDU_NO_TAGS_AVAILABLE_CREATE_FIRST: 'No tags available. Please create a tag first.',
        AI_EDU_ASSIGN_TAG: 'Assign Tag',
        AI_EDU_REMOVE_TAG: 'Remove Tag',
        AI_EDU_REMOVE_TAG_CONFIRMATION: 'Are you sure you want to remove the tag from the selected device(s)?',
        AI_EDU_REMOVE_TAG_TITLE: 'Remove Tag',
        AI_EDU_LOAD_MORE: 'Load more...',
        AI_EDU_TEMPLATE_TYPE: 'Template Type',
        AI_EDU_SIGN_IN: 'Sign In',
        AI_EDU_GET_STARTED_WITH_SAMSUNG_AI_ASSISTANT: 'Get started with Samsung Education',
        AI_EDU_CONTINUE_WITH_GOOGLE: 'Continue with Google',
        AI_EDU_CONTINUE_WITH_MICROSOFT: 'Continue with Microsoft',
        AI_EDU_SERVER_VERSION: 'Server Version',
        AI_EDU_TERMS_AND_CONDITION: 'Terms and Condition',
        AI_EDU_PRIVACY_POLICY: 'Privacy Policy',
        AI_EDU_COOKIE_POLICY: 'Cookie Policy',
        AI_EDU_I_AGREE_TO_THE: 'I agree to the',
        AI_EDU_AND_THE: 'and the',
        AI_EDU_ENTER_ORGANIZATION_NAME: 'Enter Organization Name',
        AI_EDU_ENTER_ADDRESS: 'Enter Address',
        AI_EDU_ENTER_CITY: 'Enter City',
        AI_EDU_SELECT_COUNTRY: 'Select Country',
        AI_EDU_ENTER_STATE_PROVINCE: 'Enter State/ Province',
        AI_EDU_ENTER_CODE: 'Enter Code',
        AI_EDU_COPYRIGHT_TEXT: 'Copyright © Samsung Electronics Co., Ltd. All Rights Reserved.',
    },
};

export default enUs;
